import React from "react";
import Breadcrumbs from "../../Components/Breadcrumbs/Breadcrumbs";
import EventFunFactOne from "../Events/Widgets/EventFact";
import { EventsContextProvider } from "./EventsContext/EventsContext";
import EventFilters from "./Widgets/EventFilters";
import EventMobileFilters from "./Widgets/EventMobileFilters";
import EventsList from "./Widgets/EventsList";

const EventDisplay = () => {
  return (
    <>
      <div
        //fixme
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <img
          src="/assets/covers/EVENTS.png"
          alt="Season Header"
          //fixme
          style={{
            width: "75%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <Breadcrumbs />
      <div className="container">
        <div className="row pb-20">
          <div className="offset-1 col-10">
            <p className="text-center section-text">
              Here’s a listing of all upcoming Divisional and International
              events across various locations. <br/>Find the event you're interested
              in and register your team.
            </p>
          </div>
        </div>
      </div>
      <EventsContextProvider>
        <EventMobileFilters />
        <div className="p-10 w-p-100">
          <div id="eventslist" className="row">
            <EventFilters />
            <EventsList />
          </div>
        </div>
      </EventsContextProvider>
      <EventFunFactOne
        bgClass={"bg-fact-area"}
        spaceTopClass="pt-15"
        spaceBottomClass="pb-15"
      />
    </>
  );
};

export default EventDisplay;
